import { inresiHttpService } from "utils/http";

import {
  type QuestionnairePayload,
  type QuestionnaireResponse,
  QuestionnaireResponseSchema,
} from "../schemas";

export type { QuestionnairePayload, QuestionnaireResponse };

export async function saveQuestionnaire(
  slug: string,
  payload: QuestionnairePayload
): Promise<QuestionnaireResponse["data"]> {
  const res = await inresiHttpService.post<QuestionnaireResponse>(
    `embed/${slug}/questionnaire`,
    payload,
    { schema: QuestionnaireResponseSchema }
  );
  return res.data;
}
